import {useState} from 'react';
import {observer} from 'mobx-react';
import {Panel, Spinner, ActionLink, EmployeeNameWithAvatar, Accordion} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {useFetchModel} from 'shared/hooks';
import {endpoints, types} from 'main/tools';
import {TimeOffBlockedDates} from 'main/stores/time_off';

const BlockedDateDetails = observer(({event}) => {
  const [showAllEmployees, setShowAllEmployees] = useState(false);
  const [blockedDate, isLoading] = useFetchModel(
    endpoints.TIME_OFF.BLOCKED_DATES.with(event.extendedProps.blockedDateId),
    types.TIME_OFF.BLOCKED_DATES,
    TimeOffBlockedDates
  );

  if (isLoading) return <Spinner/>;

  return (
    <div>
      <Panel.Header title={blockedDate.dateRange}/>
      <Panel.Separator/>
      <div className='h3 mb2 medium'><FormattedMessage id='calendar.blocked_dates.Types'/></div>
      <div className='mb3'>{blockedDate.typeNames}</div>
      <div className='h3 mb2 medium'><FormattedMessage id='calendar.blocked_dates.Employees'/></div>
      <div className='space-y'>
        {blockedDate.employees.slice(0, 3).map(employee => <div key={employee.id} className='mb1'>
          <EmployeeNameWithAvatar employee={employee}/>
        </div>)}
        {!showAllEmployees && <ActionLink onClick={() => setShowAllEmployees(true)}>
          <FormattedMessage id='calendar.blocked_dates.SHOW_MORE' values={{count: blockedDate.employees.length - 3}}/>
        </ActionLink>}
      </div>
      <Accordion active={showAllEmployees}>
        <div className='space-y'>
          {blockedDate.employees.slice(3).map(employee => <div key={employee.id} className='mb1'>
            <EmployeeNameWithAvatar employee={employee}/>
          </div>)}
        </div>
      </Accordion>
    </div>
  );
});

export default BlockedDateDetails;
